export default __webpack_public_path__ + "static/media/welcome-female@2x.0acfb58e.png";